import styled from 'styled-components';

export const SectionHeader = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
`;

export const SectionDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
  white-space: pre-line;
`;

export const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/** No bottom margin: the actions already overhang the label by about the Events label-to-input gap. */
export const QuestionLabelRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const QuestionTitle = styled.h2<{ $required?: boolean }>`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &::after {
    content: ${({ $required }) => ($required ? "' *'" : "' '")};
    color: ${({ theme }) => theme.palette.error.main};
  }
`;
